import { createContext, useContext, useEffect, useState } from 'react';
import CompanyService from '../services/bioplus-services/company';
import { useUserContext } from './UserContext';
import { useQuery } from 'react-query';

export const CompanyContext = createContext(undefined);

export const CompanyProvider = ({ children }) => {
  const userContext = useUserContext();
  const [rootCompany, setRootCompany] = useState();
  const [selectedCompanyId, setSelectedCompanyId] = useState();
  const query = useQuery(['company', selectedCompanyId], () =>
    CompanyService.getCompany(selectedCompanyId)
  );
  const [company, setCompany] = useState();

  if (!query.isLoading && !query.isError && company?._id !== query.data?._id) {
    setCompany(query.data);
  }

  const set = (_id) => {
    if (_id !== selectedCompanyId) {
      setSelectedCompanyId(_id);
    }
  };

  useEffect(() => {
    if (rootCompany?._id !== userContext?.company?._id) {
      setRootCompany(userContext.company);
      setSelectedCompanyId(undefined);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext?.company?._id]);

  const value = {
    company,
    set,
  };

  return <CompanyContext.Provider value={value}>{children}</CompanyContext.Provider>;
};

export const useCompany = () => {
  return useContext(CompanyContext);
};
